export default __webpack_public_path__ + "static/media/error_rojo.da348ace.png";